import { Link } from 'react-router-dom';
import { ArrowUpRight, Info } from 'lucide-react';
import { IconButton, Tooltip } from '@mui/material';
import './summaryStats.css';

export const SummaryStat = ({ label, value, context, href, description, detail }) => <div className="p-summary-stat">
    <span>{label}{description && <Tooltip title={description} arrow enterTouchDelay={0}>
        <IconButton size="small" aria-label={`Cómo se calcula ${label.toLowerCase()}`} sx={{p:0.25,ml:0.5,color:'var(--primary-color)'}}><Info size={13} aria-hidden="true" /></IconButton>
    </Tooltip>}</span><strong>{value}</strong><small>{context}</small>
    {detail && <div className="p-summary-stat-detail">{detail}</div>}
    {href && <Link to={href} aria-label={`Ver ${label.toLowerCase()}`}><ArrowUpRight size={17} aria-hidden="true" /></Link>}
</div>;
